import PropTypes from 'prop-types';

export default {
  inkDisabled: PropTypes.bool,
  inkDisabledInteractions: PropTypes.arrayOf(PropTypes.oneOf(['keyboard', 'mouse', 'touch']))
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-md/es/Inks/inkContextTypes.js
// module id = 800
// module chunks = 0